module.exports = __webpack_public_path__ + "media/images/games/memory_game/kazas/fronts/6m-4a5c120b177e3617134ac2a2bd52d152.jpg";